import { MouseEvent as ReactMouseEvent } from "react";

import { CompanyLogoAvatar } from "@/components/CompanyLogoAvatar/CompanyLogoAvatar";
import { LinkedinIcon } from "@/components/LinkedinIcon/LinkedinIcon";
import { COMPANY_ONLY_SCORE_NOTE } from "@/components/LeadScoringPopover/LeadScoringPopover";
import { renderCurrentScoreResult } from "@/pages/Private/pages/List/utils/renderCurrentScoreResult";
import { ensureHttpProtocol } from "@/utils/url";

import { MyConnections } from "@/pages/Public/pages/Login/schema/login";

function getCompanyScoreBadge(row: MyConnections) {
	const scca = row.organization?.scoreCompanyCategoryResult;
	const leadScore = scca?.leadScore;
	const category = scca?.scoreCompanyCategory?.category;
	const isCompanyOnlyScore = ["1", "2", "3"].includes(leadScore ?? "");
	const score = isCompanyOnlyScore ? `C${leadScore}` : category === "Disqualified" ? "DQ" : null;

	if (!score) {
		return null;
	}

	return renderCurrentScoreResult({
		scoring: {
			leadScoringBreakdown: isCompanyOnlyScore ? scca?.leadScoringBreakdown : null,
			overallReasoning: isCompanyOnlyScore
				? scca?.leadScoringReasoning || scca?.reason
				: scca?.reason,
		},
		note: isCompanyOnlyScore ? COMPANY_ONLY_SCORE_NOTE : undefined,
		score,
	});
}

interface ConnectionCompanyCellProps {
	row: MyConnections;
	handleCopyClick: (value: string) => void;
}

export function ConnectionCompanyCell({ row, handleCopyClick }: ConnectionCompanyCellProps) {
	const scoreBadge = getCompanyScoreBadge(row);
	const companyName = row.organization?.name || row.companyName || null;
	const logoUrl = row.organization?.logoUrl ?? null;
	const linkedinUrl = row.organization?.linkedinUrl ?? null;

	return (
		<div className="flex items-center gap-1.5">
			{scoreBadge}
			{companyName && <CompanyLogoAvatar logoUrl={logoUrl} name={companyName} size="sm" />}
			<button
				className="text-sm text-gray-700 text-ellipsis overflow-hidden max-w-[200px] cursor-pointer"
				type="button"
				onClick={(e: ReactMouseEvent) => {
					e.preventDefault();
					e.stopPropagation();
					if (companyName) {
						handleCopyClick(companyName);
					}
				}}
			>
				{companyName || "-"}
			</button>
			{linkedinUrl && (
				<a
					href={ensureHttpProtocol(linkedinUrl)}
					rel="noreferrer"
					target="_blank"
					onClick={(e: ReactMouseEvent) => e.stopPropagation()}
				>
					<LinkedinIcon status="checked" />
				</a>
			)}
		</div>
	);
}
